export const LEAD_SOURCES = [
  "Website", "Meta Ads", "Google Ads", "Instagram", "Facebook",
  "LinkedIn", "Referral", "Walk-in", "Phone Call", "WhatsApp", "Other",
];

export const LEAD_STATUSES = [
  "New Lead", "Contacted", "Demo Scheduled", "Follow-up",
  "Interested", "Payment Pending", "Converted", "Lost",
];

// Badge style per status
export const STATUS_STYLE = {
  "New Lead": "bg-slate-100 text-slate-700",
  "Contacted": "bg-sky-100 text-sky-700",
  "Demo Scheduled": "bg-violet-100 text-violet-700",
  "Follow-up": "bg-amber-100 text-amber-700",
  "Interested": "bg-cyan-100 text-cyan-700",
  "Payment Pending": "bg-orange-100 text-orange-700",
  "Converted": "bg-accent/15 text-green-700",
  "Lost": "bg-rose-100 text-rose-700",
};

// Top border accent per kanban column
export const STATUS_ACCENT = {
  "New Lead": "border-t-slate-400",
  "Contacted": "border-t-sky-400",
  "Demo Scheduled": "border-t-violet-400",
  "Follow-up": "border-t-amber-400",
  "Interested": "border-t-cyan-400",
  "Payment Pending": "border-t-orange-400",
  "Converted": "border-t-accent",
  "Lost": "border-t-rose-400",
};

export const STATUS_DOT = {
  "New Lead": "#94A3B8",
  "Contacted": "#0EA5E9",
  "Demo Scheduled": "#8B5CF6",
  "Follow-up": "#F59E0B",
  "Interested": "#06B6D4",
  "Payment Pending": "#F97316",
  "Converted": "#22C55E",
  "Lost": "#EF4444",
};

export const fmtMoney = (n) =>
  new Intl.NumberFormat("en-IN", { style: "currency", currency: "INR", maximumFractionDigits: 0 }).format(n || 0);
